import View from './View'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'


class ListView extends View {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    const items = [...container.querySelectorAll(".list-view-item")]
    TweenMax.set(items, {y: 0, opacity: 1})
    TweenMax.from(items, .1, {opacity: 0, delay: (i) => .35 + i * .05, ease: Power3.easeOut})
    TweenMax.from(items, .4, {y: 100, delay: (i) => .35 + i * .05, ease: Power3.easeOut})
    
    
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    
    const items = [...container.querySelectorAll(".list-view-item")]
    TweenMax.to(items, .4, {y: 100, opacity: 0, delay: (i) => i * .04, ease: Power3.easeIn})
    
  }

}

export default ListView